<template>
  <div v-if="resultPage === 0" class="home">
    <ProgressStep step=4 />
    <h1>Résultat</h1>
    <div class="resultFrameSure">
      <img src="assets/icon/eligible.svg" alt="Vous êtes éligible !">
      <p>Tu es éligible !</p>
    </div>
    <p>
      Bonne nouvelle ! <br>
      D’après les informations fournies, tu es éligible à la bourse Y Not.
    </p>
    <p>
      Nous t'invitons à remplir un dossier de candidature en cliquant sur le bouton ci-dessous.
    </p>
    <button @click="startCandidature()" class="submit-button" type="submit">Dossier de candidature</button>
    <button @click="leaveCandidature()" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Quitter le formulaire</span>
    </button>
  </div>
  <div v-if="resultPage === 1" class="home">
    <ProgressStep step=4 />
    <h1>Résultat</h1>
    <div class="resultFrameNotSure">
      <p>Tu es peut-être éligible</p>
    </div>
    <p>
      Les informations fournies ne nous permettent pas d’établir avec certitude ton éligibilité à la bourse Y Not.
    </p>
    <p>
      Nous t'invitons à remplir un dossier de candidature en cliquant sur le bouton ci-dessous.
    </p>
    <button @click="startCandidature()" class="submit-button" type="submit">Dossier de candidature</button>
    <button @click="leaveCandidature()" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Quitter le formulaire</span>
    </button>
  </div>
  <div v-if="resultPage === 2" class="home">
    <ProgressStep step=4 />
    <h1>Résultat</h1>
    <div class="resultFrameNot">
      <img src="assets/icon/non-eligible.svg" alt="Vous n'êtes pas éligible !">
      <p>Tu n'es pas éligible !</p>
    </div>
    <p>
      D’après les informations que tu nous as fournies, tu n’es pas éligible à notre programme de bourse Y Not.
    </p>
    <div class="failFrame">
      <button @click="$router.push({ name: 'Home' })" class="submit-button-back" type="submit">
        <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
        <span>Recommencer la simulation</span>
      </button>
      <button @click="leaveCandidature()" class="submit-button-back reverseItem">
        <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
        <span>Quitter le formulaire</span>
      </button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressStep from '@/components/ProgressStep.vue'

export default {
  name: 'Etape0',
  components: {
    ProgressStep
  },
  data () {
    return {
      resultPage: 0,
      pts: 0,
      score: null,
      table: [
      //RBG: 0      1      2      3      4      5      6    7         POINTS DE CHARGE
          [33100, 22500, 18190, 16070, 13990, 11950, 7540, 250],   // 0
          [36760, 25000, 20210, 17850, 15540, 13280, 8370, 500],   // 1
          [40450, 27500, 22230, 19640, 17100, 14600, 9220, 750],   // 2
          [44120, 30000, 24250, 21430, 18640, 15920, 10050, 1000], // 3
          [47800, 32500, 26270, 23210, 20200, 17250, 10880, 1250], // 4
          [51480, 35010, 28300, 25000, 21760, 18580, 11730, 1500], // 5
          [55150, 37510, 30320, 26770, 23310, 19910, 12570, 1750], // 6
          [58830, 40010, 32340, 28560, 24860, 21240, 13410, 2000], // 7
          [62510, 42510, 34360, 30350, 26420, 22560, 14240, 2250], // 8
          [66180, 45000, 36380, 32130, 27970, 23890, 15080, 2500], // 9
          [69860, 47510, 38400, 33920, 29520, 25220, 15910, 2750], // 10
          [73540, 50010, 40410, 35710, 31090, 26540, 16750, 3000], // 11
          [77210, 52500, 42430, 37490, 32630, 27870, 17590, 3250], // 12
          [80890, 55000, 44450, 39280, 34180, 29200, 18420, 3500], // 13
          [84560, 57520, 46480, 41050, 35750, 30530, 19270, 3750], // 14
          [88250, 60010, 48500, 42840, 37300, 31860, 20110, 4000], // 15
          [91920, 62510, 50520, 44630, 38840, 33190, 20940, 4250], // 16
          [95610, 65010, 52540, 46410, 40400, 34510, 21780, 4500], // 17
      ]
    }
  },
  mounted () {
    this.pts += this.$store.state.nChild * 2
    this.pts += this.$store.state.nChildUp * 4
    this.$store.state.range >= 30 && this.$store.state.range <= 249 && (this.pts += 1)
    this.$store.state.range >= 250 && (this.pts += 2)
    this.calcFinal()
  },
  methods: {
    startCandidature () {
      window.location.href = 'https://bourses.yschools.fr/dossier-de-candidature'
    },
    leaveCandidature () {
      window.location.href = 'https://bourses.yschools.fr/'
    },
    calcFinal () {
      var chargePts = this.pts
      var data = this.table
      chargePts > data.length && (chargePts = (data.length -1))
      const RBG = this.$store.state.income
      var result = {
        state: false,
        stage: null
      }

      for (let i=0;i<data[chargePts].length;i++) {
        if (RBG<data[chargePts][i]) {
          result.state = true
          result.stage = i
        }
      }

      if (result.state === true && 
      (this.$store.state.location === '10 - Aube' ||
      this.$store.state.location === '52 - Haute-Marne' ||
      this.$store.state.location === '8 - Ardennes' ||
      this.$store.state.location === '57 - Moselle') && 
      (this.$store.state.diploma !== 6)) {
        this.resultPage = 0
        this.score = result.stage
      } else if (result.state === true && this.$store.state.diploma !== 6) {
        this.resultPage = 1
        this.score = 'Sous réserve'
      } else {
        this.resultPage = 2
        this.score = 'Incompatible'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    margin-top: 30px;
  }
  .resultFrameSure {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 20px;
    background-color: #E8F5E9;
    border-radius: 10px;
    margin-top: 30px;
    p {
      padding: unset;
      margin: unset;
      font-size: 20px;
      font-weight: 700;
      color: #1C5D20;
    }
    img {
      margin-right: 22px;
    }
  }
  .resultFrameNotSure {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 20px;
    background-color: #E5E9F6;
    border-radius: 10px;
    margin-top: 30px;
    p {
      padding: unset;
      margin: unset;
      font-size: 20px;
      font-weight: 700;
      color: var(--color-primary);
    }
    img {
      margin-right: 22px;
    }
  }
  .resultFrameNot {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 20px;
    background-color:#FBE9E7;
    border-radius: 10px;
    margin-top: 30px;
    p {
      padding: unset;
      margin: unset;
      font-size: 20px;
      font-weight: 700;
      color: #BF360D;
    }
    img {
      margin-right: 22px;
    }
  }
  .submit-button-back {
    text-align: left;
  }
  .submit-button {
    display: flex;
    justify-content: center;
  }
  .failFrame {
    display: flex;
    justify-content: space-between;
  }
  .reverseItem {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    img {
      transform: rotateZ(180deg);
    }
  }
  @media screen and (min-width: 585px) {
    h1 {
      margin-top: 61px;
    }
  }
</style>
